<template>
    <form autocomplete="off">
        <q-toggle
                v-model="details.enabled"
                label="Включен"
        />
        <q-field>
            <q-input
                    v-model="details.requisites.edrpou"
                    stack-label="ЕДРПОУ"
            />
        </q-field>
        <q-field>
            <q-input
                    v-model="details.requisites.checking_account"
                    stack-label="Рассчетный счет"
            />
        </q-field>
        <q-field>
            <q-input
                    v-model="details.requisites.company_name"
                    stack-label="Название компании"
            />
        </q-field>
        <div class="q-mt-lg row justify-end items-center">
            <div>
                <q-btn
                        @click="save()"
                        :loading="saving"
                        label="Сохранить"
                        color="primary"
                />
                <q-btn
                        @click="$emit('close')"
                        color="primary"
                        flat
                        label="Закрыть"
                />
            </div>
        </div>
    </form>
</template>

<script>
  import harvester from './mixins/harvester'

  import {
    QField,
    QInput,
    QToggle,
    QBtn,
  } from 'quasar'

  export default {
    name: 'Privat24Method',
    components: {
      QField,
      QInput,
      QToggle,
      QBtn
    },
    mixins: [
      harvester
    ],
    props: {
      provider: Object,
      details: {
        type: Object,
        default () {
          return {
            enabled: false,
            payment_method: 'privat24',
            requisites: {
              edrpou: '',
              checking_account: '',
              company_name: ''
            }
          }
        }
      }
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PaymentMethodEdit/methods/Privat24Method.vue